export const ADD_MEALS = 'ADD_MEALS'
export const ADD_MEAL = 'ADD_MEAL'
export const LOAD_MEAL = 'LOAD_MEAL'
export const ADD_MEAL_SALE_ELEMENTS = 'ADD_MEAL_SALE_ELEMENTS'

